import { api } from './baseAPI';
import { ApiResponse, ListResponse } from '../types/api';
import {
  ContactFormData,
  ContactCheckFormData,
  ContactSubmitResponse,
  ContactListResponse,
  ContactCheckResponse,
  DetailedContact
} from '../types/contact';

// 문의하기 관련 API
export const contactAPI = {
  // 문의하기 제출
  submitContact: async (contactData: ContactFormData): Promise<ContactSubmitResponse> => {
    const response = await api.post('/contact/submit', contactData);
    return response.data;
  },

  // 공개 문의 목록 조회 (제목만)
  getPublicContacts: async (params?: { page?: number; limit?: number }): Promise<ContactListResponse> => {
    const response = await api.get('/contact/public', { params });
    return response.data;
  },

  // 비회원 문의 조회
  checkContact: async (contactData: ContactCheckFormData): Promise<ContactCheckResponse> => {
    const response = await api.post('/contact/check', contactData);
    return response.data;
  },

  getContacts: async (params?: { status?: string; page?: number; limit?: number; offset?: number; searchField?: string }): Promise<ApiResponse<ListResponse<DetailedContact>>> => {
    const response = await api.get('/contact', { params });
    return response.data;
  },

  getContact: async (contactId: string): Promise<ApiResponse<DetailedContact>> => {
    const response = await api.get(`/contact/${contactId}`);
    return response.data;
  },

  replyContact: async (contactId: string, reply: string): Promise<ApiResponse<DetailedContact>> => {
    const response = await api.post(`/contact/${contactId}/reply`, { reply });
    return response.data;
  },

  updateContactStatus: async (contactId: string, status: string): Promise<ApiResponse<DetailedContact>> => {
    const response = await api.patch(`/contact/${contactId}/status`, { status });
    return response.data;
  },
};

export default contactAPI;